import React from 'react';
import { jsPDF } from "jspdf";

import {
    Button
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import printModal from '../assets/svg/print-modal.svg'
import Save from '../assets/svg/save.svg';
import { API_ENDPOINT } from '../constants';

/**
* Open print page of browser, generate Save PDF button
* @author   Milan Stanojevic
*/
class PrintHelper extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {

    }

    render() {
        return (
            <div style={{ width: '100%' }}>


                <Button color='primary' style={{ width: '100%' }} onClick={async () => {
                    try {
                        if (this.props._greekJournalNote) {
                            const response = await fetch(API_ENDPOINT + '/chat/journal-note/print', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`
                                },
                                body: JSON.stringify({
                                    journalNote: this.props._greekJournalNote,
                                    fileName: this.props.pdfName,
                                })
                            });

                            if (response.status === 200) {
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = this.props.pdfName;
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                                window.URL.revokeObjectURL(url);
                            }

                            return;
                        }

                    } catch (err) {
                        console.log(err)
                    }
                    const doc = new jsPDF('p', 'mm', [210, 297]);
                    doc.html(`<div style="width:1100px;padding: 100px 50px;">${this.props.html}</div>`, {
                        margin: [20, 20, 20, 20],

                        html2canvas: {
                            scale: 0.1909
                        },

                        callback: () => {
                            this.setState({
                                blob: doc.output('bloburl'),
                                docObj: doc
                            }, () => {
                                this.state.docObj.save(this.props.pdfName);

                            })
                        },

                    })

                }}>
                    {/* <Isvg src={Save} style={{ marginRight: 5 }} /> */}
                    {'Save as pdf'.translate(this.props.lang)}
                </Button>


                <iframe width="0" height="0" style={{ border: 0 }} src={this.state.blob} ref={(node) => this.iframe = node} onLoad={() => this.setState({ _loaded: true })}></iframe>

            </div>
        )
    }
}

export default PrintHelper;